import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _ShowGetter = Getter.of();
export const _ShowResponseGetter = Getter.of();
export const _ShowsGetter = Getter.of();
export const _ShowsResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _ShowsResponse2Shows = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _ShowResponse2Show = _Response2ResponseData();
export const _Shows2Show = Fold.compose(_ShowsGetter, Res._ForEach());
export const _Show2Data = Fold.compose(_ShowGetter, Res._Response());
export const _Show2Attributes = Fold.compose(_Show2Data, Lens.prop("attributes"));
export const _ShowAttributes2AlternateId = Fold.compose(_Show2Attributes, Lens.prop("alternateId"));
export const _ShowAttributes2AnalyticsId = Fold.compose(_Show2Attributes, Lens.prop("analyticsId"));
export const _ShowAttributes2AudioTracks = Fold.compose(_Show2Attributes, Lens.prop("audioTracks"));
export const _ShowAttributes2Collections = Fold.compose(_Show2Attributes, Lens.prop("collections"));
export const _ShowAttributes2ContentRatings = Fold.compose(_Show2Attributes, Lens.prop("contentRatings"));
export const _ShowAttributes2ContentDescriptors = Fold.compose(_Show2Attributes, Lens.prop("contentDescriptors"));
export const _ShowAttributes2CustomAttributes = Fold.compose(_Show2Attributes, Lens.prop("customAttributes"));
export const _ShowAttributes2Description = Fold.compose(_Show2Attributes, Lens.prop("description"));
export const _ShowAttributes2EpisodeCount = Fold.compose(_Show2Attributes, Lens.prop("episodeCount"));
export const _ShowAttributes2GeoRestrictions = Fold.compose(_Show2Attributes, Lens.prop("geoRestrictions"));
export const _ShowAttributes2HasExpiringEpisodes = Fold.compose(_Show2Attributes, Lens.prop("hasExpiringEpisodes"));
export const _ShowAttributes2HasNewEpisodes = Fold.compose(_Show2Attributes, Lens.prop("hasNewEpisodes"));
export const _ShowAttributes2LongDescription = Fold.compose(_Show2Attributes, Lens.prop("longDescription"));
export const _ShowAttributes2IsFavorite = Fold.compose(_Show2Attributes, Lens.prop("isFavorite"));
export const _ShowAttributes2MinimumAge = Fold.compose(_Show2Attributes, Lens.prop("minimumAge"));
export const _ShowAttributes2Name = Fold.compose(_Show2Attributes, Lens.prop("name"));
export const _ShowAttributes2NewestEpisodePublishStart = Fold.compose(_Show2Attributes, Lens.prop("newestEpisodePublishStart"));
export const _ShowAttributes2PublishEnd = Fold.compose(_Show2Attributes, Lens.prop("publishEnd"));
export const _ShowAttributes2PublishStart = Fold.compose(_Show2Attributes, Lens.prop("publishStart"));
export const _ShowAttributes2SeasonNumbers = Fold.compose(_Show2Attributes, Lens.prop("seasonNumbers"));
export const _ShowAttributes2Subtitles = Fold.compose(_Show2Attributes, Lens.prop("subtitles"));
export const _ShowAttributes2UniversalId = Fold.compose(_Show2Attributes, Lens.prop("universalId"));
export const _ShowAttributes2VideoCount = Fold.compose(_Show2Attributes, Lens.prop("videoCount"));
export const _ShowAttributes2WebExclusive = Fold.compose(_Show2Attributes, Lens.prop("webExclusive"));
export const _Show2PrimaryChannel = Fold.compose(_ShowGetter, Res._Rel("primaryChannel"));
export const _Show2Genres = Fold.compose(_ShowGetter, Res._Rel("genres"), Res._ForEach());
export const _Show2Images = Fold.compose(_ShowGetter, Res._Rel("images"), Res._ForEach());
export const _Show2Routes = Fold.compose(_ShowGetter, Res._Rel("routes"), Res._ForEach());
export const _Show2Seasons = Fold.compose(_ShowGetter, Res._Rel("seasons"), Res._ForEach());
export const _Show2ContentPackages = Fold.compose(_ShowGetter, Res._Rel("contentPackages"), Res._ForEach());
export const _Show2Ratings = Fold.compose(_ShowGetter, Res._Rel("ratings"), Res._ForEach());
export const _Show2RatingDescriptors = Fold.compose(_ShowGetter, Res._Rel("ratingDescriptors"), Res._ForEach());
export const _Show2TxBadges = Fold.compose(_ShowGetter, Res._Rel("txBadges"), Res._ForEach());
export const _Show2TxGenres = Fold.compose(_ShowGetter, Res._Rel("txGenres"), Res._ForEach());
export const _Show2TxDiscoverySuperstars = Fold.compose(_ShowGetter, Res._Rel("txDiscoverySuperstars"), Res._ForEach());
export const _Show2TxLearning = Fold.compose(_ShowGetter, Res._Rel("txLearning"), Res._ForEach());
export const _Show2TxMisc = Fold.compose(_ShowGetter, Res._Rel("txMisc"), Res._ForEach());
export const _Show2TxMood = Fold.compose(_ShowGetter, Res._Rel("txMood"), Res._ForEach());

